import Vue from 'vue';
import AsyncComputed from 'vue-async-computed';
import './registerServiceWorker';
import {Plugin} from 'vue-fragment';
import 'babel-polyfill';

// Font Awesome
import {library} from '@fortawesome/fontawesome-svg-core';
import {faCodeBranch, faFileExport} from '@fortawesome/free-solid-svg-icons';
import {faLinux, faApple, faWindows} from '@fortawesome/free-brands-svg-icons';
import {FontAwesomeIcon} from '@fortawesome/vue-fontawesome';

// Google Analytics
import VueAnalytics from 'vue-analytics';
import vuetify from './plugins/vuetify';
import Logger from './services/serverLogger.service';
import store from './store';
import router from './router';
import App from './App';

// import ECharts modules manually to reduce bundle size
import 'echarts/lib/chart/bar';
import 'echarts/lib/chart/line';
import 'echarts/lib/component/polar';
import 'echarts/lib/component/tooltip';

// Filters
import pretty from './filters/pretty.filter';
import timeago from './filters/timeago.filter';
import teststatus from './filters/teststatus.filter';
import duration from './filters/duration.filter';
import enabled from './filters/enabled.filter';
import date from './filters/date.filter';
import truncate from './filters/truncate.filter';
import os from './filters/os.filter';
import browser from './filters/browser.filter';

Vue.config.productionTip = false;

// Font Awesome
library.add(faCodeBranch, faFileExport, faLinux, faApple, faWindows);
Vue.component('font-awesome-icon', FontAwesomeIcon);

Vue.use(Plugin); // vue-fragment so you can have "multiple" root elements used so we can drop multiple <td>s into a <tr>, for example

if (process.env.VUE_APP_GOOGLE_ANALYTICS_ID) {
  Vue.use(VueAnalytics, {
    id: process.env.VUE_APP_GOOGLE_ANALYTICS_ID,
    router
  });
}

Vue.use(AsyncComputed);

Vue.config.errorHandler = Logger.vueErrorHandler;
Vue.filter('pretty', pretty);
Vue.filter('date', date);
Vue.filter('truncate', truncate);
Vue.filter('teststatus', teststatus);
Vue.filter('timeago', timeago);
Vue.filter('duration', duration);
Vue.filter('enabled', enabled);
Vue.filter('os', os);
Vue.filter('browser', browser);

new Vue({
  router,
  store,
  vuetify,
  render: (h) => h(App)
}).$mount('#app');
